<div class="content p-24">

    <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <form class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto" name="form" [formGroup]="form" (ngSubmit)="onSubmit()">

            <div class="h2 mb-24">{{'Resource data'|translate}}</div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Name'|translate}}</mat-label>
                    <input matInput formControlName="name" required>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <mat-error>{{'Name is required!'|translate}}</mat-error>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'Serial number'|translate}}</mat-label>
                    <input matInput formControlName="serialNumber">
                </mat-form-field>
                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'Device ID'|translate}}</mat-label>
                    <input matInput formControlName="deviceId">
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="enableCalendar" fxFlex="25">
                    <mat-label>{{'Enable calendar'|translate}}</mat-label>
                </mat-checkbox>
                <mat-checkbox formControlName="alwaysActiveInCalendar" fxFlex="25">
                    <mat-label>{{'Always active in calendar'|translate}}</mat-label>
                </mat-checkbox>
                <mat-checkbox formControlName="enableAutomaticPayments" fxFlex="25">
                    <mat-label>{{'Enable automatic payments'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-checkbox formControlName="isActive" fxFlex="25">
                    <mat-label>{{'Is active'|translate}}</mat-label>
                </mat-checkbox>
                <mat-checkbox formControlName="isRegistered" fxFlex="25">
                    <mat-label>{{'Is registered'|translate}}</mat-label>
                </mat-checkbox>
                <mat-checkbox formControlName="isFiscalPrinter" fxFlex="25">
                    <mat-label>{{'Fiscal printer'|translate}}</mat-label>
                </mat-checkbox>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="80">
                    <mat-label>{{'Category' | translate}}</mat-label>
                    <mat-select formControlName="category">
                        <mat-option [value]="category.id" *ngFor="let category of categories">
                            {{category.name}}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                </mat-form-field>
                <div fxFlex="20" style="padding-left: 20px;">
                    <a mat-raised-button color="primary" (click)="addCategory()">{{'Add category' | translate}}</a>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="80">
                    <mat-label>{{'Type' | translate}}</mat-label>
                    <mat-select formControlName="type">
                        <mat-option [value]="type.id" *ngFor="let type of resourceTypes">
                            {{type.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>


            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Description'|translate}}</mat-label>
                    <textarea matInput formControlName="description"></textarea>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'Calendar priority'|translate}}</mat-label>
                    <input matInput formControlName="calendarPriority" type="number">
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">

                <mat-form-field appearance="outline" fxFlex="50" class="pr-4">
                    <mat-label>{{'Reservation time'|translate}}</mat-label>
                    <input matInput formControlName="reservationTime" type="number">
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>{{'Required credits'|translate}}</mat-label>
                    <input matInput formControlName="requiredCredits" type="number">
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <div fxLayout="row" fxLayoutAlign="center center">
                    <button mat-raised-button type="submit" color="accent" [disabled]="processing">
                        <span *ngIf="!processing">{{'Save'|translate}}</span>
                        <span *ngIf="processing">{{'Saving'|translate}}</span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
